import { useEffect, useState } from 'react'
import { consumirApi } from '../../utils/consumoApi'
import { API_BASE_URL } from '../../utils/config.js' 
import { agregarDatosEmpresaUsuario } from '../../utils/empresaUsuario'
import ErrorAlert from './../../components/common/ErrorAlert'
import Table from './../../components/tables/TableFilter'
import Button from './../../components/common/Button'
import Modal from './../../components/modals/Modal'
import ModalConfirmacion from './../../components/modals/ModalConfirmacion'
import Form from './../../components/forms/Form'
import Input from './../../components/common/Input'
import Notification from './../../components/common/Notification'
import Spinner from './../../components/common/Spinner'
import { FaFileExcel  } from "react-icons/fa"

const Proveedores = () => {
  const [datos, setDatos] = useState([])
  const idEmpresa = JSON.parse(localStorage.getItem('empresa'))
  // campos 
  const [idProveedor, setIdProveedor] = useState("")
  const [tipoPersona, setTipoPersona] = useState("0")
  const [documento, setDocumento] = useState("")
  const [nombres, setNombres] = useState("")
  const [domicilio, setDomicilio] = useState("")
  const [telefono, setTelefono] = useState("")
  const [email, setEmail] = useState("")
  const [filtroEstado, setFiltroEstado] = useState('1') // Por defecto "1" (ACTIVO)
  // modales 
  const [mostrarModal, setMostrarModal] = useState(false)
  const [mostrarModalEditar, setMostrarModalEditar] = useState(false)
  const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false)
  // notificaciones y cargas 
  const [cargando, setCargando] = useState(true)
  const [cargandoReniec, setCargandoReniec] = useState(false)
  const [error, setError] = useState("")
  const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
  // eliminar un proveedor 
  const [selectedId, setSelectedId] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  //datos para la tabla
  const columnas = [
    { titulo: 'Tipo documento', campo: 'tipo_persona' },
    { titulo: 'Documento', campo: 'documento_proveedor' },
    { titulo: 'Nombres', campo: 'nombres_proveedor' },
    { titulo: 'Dirección', campo: 'domicilio_proveedor' },
    { titulo: 'Telefono', campo: 'telefono_proveedor' },
    { titulo: 'Email', campo: 'email_proveedor' },
    { titulo: 'Estado', campo: 'estado' },
  ]

  // Carga inicial de los Proveedores
  useEffect(() => { obtenerProveedores() }, [filtroEstado])

  // Funcion para buscar en la BD de RENIEC el DNI
  const obtenerPersona = async (dni) => {
    setDocumento(dni)
    setNombres('')
    if (dni.length === 8 && tipoPersona === '0') {
      setCargandoReniec(true)
      const respuesta = await consumirApi('GET', `reniec/${dni}`)
      const datos = respuesta.data[0]
      if (datos) {
        setNombres(datos.nombre + ' ' + datos.ape_pat + ' ' + datos.ape_mat)
      }
      setCargandoReniec(false)
    }
  }

  // Funcion para obtener los Proveedores
  const obtenerProveedores = async () => {
    const respuesta = await consumirApi('GET', `proveedor/${idEmpresa}/${filtroEstado}`)
    setDatos(respuesta.success ? respuesta.data : respuesta.error)
    setCargando(false)
  }

  // Funcion para registrar un nuevo proveedor
  const registrarProveedor = (async (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    agregarDatosEmpresaUsuario(formData)
    setIsSubmitting(true)
    const respuesta = await consumirApi('POST', `proveedor`, formData)
    if (respuesta.success) {
      setNotificacion({ estado: true, tipo: "registro", mensaje: "Proveedor registrado correctamente" })
      limpiarCampos()
      obtenerProveedores()
    }
    else {
      setError(respuesta.error)
      setIsSubmitting(false)
    }
  })

  // funcion para abrir el modal para editar proveedor
  const abrirModalEditar =  (data) => {
    setIdProveedor(data.id)
    setDocumento(data.documento_proveedor)
    setNombres(data.nombres_proveedor)
    setDomicilio(data.domicilio_proveedor)
    setTelefono(data.telefono_proveedor)
    setEmail(data.email_proveedor)
    setMostrarModalEditar(true)
  }

  // Edición proveedor
  const enviarEdicionProveedor = async (e) => {
    e.preventDefault()
    const data = { documento_proveedor: documento, nombres_proveedor: nombres, domicilio_proveedor: domicilio, telefono_proveedor: telefono, email_proveedor:email }
    setIsSubmitting(true)
    const respuesta = await consumirApi('PATCH', `proveedor/${idProveedor}`, data)
    if (respuesta.success) {
      setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Proveedor actualizado correctamente" })
      limpiarCampos()
      obtenerProveedores()
    } else {
      setError(respuesta.error)
      setIsSubmitting(false)
    }
  }

  // Manejar selección de checkbox
  const seleccionProveedor = (data) => {
    setSelectedId((prevSelectedId) => (prevSelectedId === data.id ? null : data.id))
  }

  const eliminarProveedor = async () => {
    const respuesta = await consumirApi('DELETE', `proveedor/${selectedId}`)
    if (respuesta.success) {
      setNotificacion({ estado: true, tipo: "eliminar", mensaje: "Proveedor eliminado correctamente" })
      limpiarCampos()
      obtenerProveedores()
    } else {
      setError(respuesta.error)
    }
  }

   // funcion para abrir el modal para editar TipoTerreno
   const actualizarEstadoProveedor = async () => {
        const respuesta = await consumirApi('PATCH', `proveedor/${selectedId}/estado`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Estado de proveedor actualizado correctamente" })
            limpiarCampos()
            obtenerProveedores()
        } else {
            setError(respuesta.error)
        }
    }

    const manejarCambioFiltro = (e) => {
      setFiltroEstado(e.target.value)
      setSelectedId(null)
    }

  const limpiarCampos = () => {
    setMostrarModal(false)
    setMostrarModalEditar(false)
    setMostrarModalEliminar(false)
    setError('')
    setSelectedId(null)
    setDocumento('')
    setNombres('')
    setDomicilio('')
    setTelefono('')
    setEmail('')
    setTimeout(() => {
      setIsSubmitting(false)
    }, 300)
  }

  return (
    <div className='w-full min-h-[calc(100vh-50px)]'>
      <Button className="ml-5 mt-2" texto='+ Nuevo' onClick={() => setMostrarModal(true)} />
      <Button className="ml-3 mt-2" type="delete" disabled={!selectedId} onClick={()=>setMostrarModalEliminar(true)} />
      <Button className="mx-3 mt-2" texto=" &#x21bb;" type="update" disabled={!selectedId} onClick={actualizarEstadoProveedor} />
      <select className="border rounded-md p-1 mt-2" value={filtroEstado} onChange={manejarCambioFiltro} >
          <option value="1">ACTIVO</option>
          <option value="0">INHABILITADO</option>
          <option value="all">TODOS</option>
        </select>
      <FaFileExcel size={30} color="green" className="ml-3 mt-0 inline cursor-pointer" onClick={() => window.open(`${API_BASE_URL}/export/proveedores/${idEmpresa}`, "_blank")} />
      {notificacion.estado && (
        <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
      )}
      {cargando ? (
        <Spinner />
      ) : (
        datos.length === 0 ? (
          <div className="ml-5 mt-2">No se encontraron Proveedores</div>
        ) : (
          <Table datos={datos} listaCampos={columnas} editarRegistro={abrirModalEditar}
            mostrarChecks={true}
            seleccionFila={seleccionProveedor} // Manejar el ID seleccionado
            selectedId={selectedId} // Manejar el ID seleccionado
          />
        )
      )}

      {/* Modal Registrar nuevo proveedor*/}
      <Modal isOpen={mostrarModal} title="Registrar nuevo proveedor" onClose={limpiarCampos} >
        <Form onSubmit={registrarProveedor} isSubmitting={isSubmitting}>
          <Input name="tipo_persona" value={tipoPersona} label="Tipo de documento" type="select" onChange={setTipoPersona}
            options={[
              { value: "0", label: "DNI" },
              { value: "1", label: "RUC" },
            ]}
          />
          <Input name="documento_proveedor" value={documento} label="Documento" type='number' onChange={obtenerPersona} carga={cargandoReniec} />
          <Input name="nombres_proveedor" value={nombres} label="Nombres" onChange={setNombres} />
          <Input name="domicilio_proveedor" value={domicilio} label="Dirección" onChange={setDomicilio} />
          <Input name="telefono_proveedor" value={telefono} label="Telefono" onChange={setTelefono} />
          <Input name="email_proveedor" value={email} label="Email" onChange={setEmail} />
          
          {error && <ErrorAlert message={error} />}
        </Form>
      </Modal>

      {/* Modal Actuazliar proveedor*/}
      <Modal isOpen={mostrarModalEditar} title="Actualizar Proveedor" onClose={limpiarCampos} >
        <Form onSubmit={enviarEdicionProveedor}  isSubmitting={isSubmitting} type='update'>
          <Input name="documento_proveedor" value={documento} label="Documento" type='number' onChange={obtenerPersona} carga={cargandoReniec} />
          <Input name="nombres_proveedor" value={nombres} label="Nombres" onChange={setNombres} />
          <Input name="domicilio" value={domicilio} label="Dirección" onChange={setDomicilio} />
          <Input name="telefono" value={telefono} label="Telefono" onChange={setTelefono} />
          <Input name="email_proveedor" value={email} label="Email" onChange={setEmail} />
          {error && <ErrorAlert message={error} />}
        </Form>
      </Modal>

      {/* Modal de confirmación para eliminar un proveedor*/}
      <ModalConfirmacion
        isOpen={mostrarModalEliminar}
        onClose={limpiarCampos}
        onConfirm={eliminarProveedor}
        mensaje="¿Estás seguro de que deseas eliminar proveedor?"
      >
        {error && <ErrorAlert message={error} />}
      </ModalConfirmacion>
    </div>
  )
}

export default Proveedores
